const TimeOfDay = {
  DAY_TIME: 0,
  NIGHT_TIME: 1,
};

export default TimeOfDay;
